import { render } from "./DashboardMain.vue?vue&type=template&id=c95e614c&scoped=true"
import script from "./DashboardMain.vue?vue&type=script&lang=js"
export * from "./DashboardMain.vue?vue&type=script&lang=js"

import "./DashboardMain.vue?vue&type=style&index=0&id=c95e614c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95e614c"]])

export default __exports__